const PHRASE = "Emma & Jhonny — 10 · 10 · 2026 — Nos Casamos — ";

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-clay/10 bg-sand py-5 select-none">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((i) => (
        <span key={i} aria-hidden={i === 1} className="font-serif italic text-clay/80 text-xl md:text-2xl pr-2">
          {PHRASE.repeat(6)}
        </span>
      ))}
    </div>
  </div>
);
